import { createTheme } from "@mui/material/styles";

// Tema oscuro Portal EBG, derivado del azul institucional #1e3d52.
// Tokens (ver handoff de diseno):
//   bg #0b141d · surface #111e2b · surface-2 #16283a · sidebar #0e1a26
//   border #1c2f42 · border-2 #23394d · accent #4da3d8 · accent-hi #9ed1f2
//   gold #d9a441 · green #4cc38a · red #e5646e · text #e8eef4 · muted #8ba3b8
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#4da3d8", contrastText: "#0b141d" },
    secondary: { main: "#d9a441" },
    success: { main: "#4cc38a" },
    warning: { main: "#d9a441" },
    error: { main: "#e5646e" },
    danger: { main: "#e5646e" },
    background: { default: "#0b141d", paper: "#111e2b" },
    divider: "#1c2f42",
    text: { primary: "#e8eef4", secondary: "#8ba3b8" },
  },
  typography: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none", border: "1px solid #1c2f42" },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: "#8ba3b8",
          fontSize: 11.5,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.6,
        },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#111e2b",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#23394d" },
        },
      },
    },
  },
});

export default theme;
